<script setup>
import Cruise from '@/components/home/Cruise.vue'
</script>
<template>
  <section class="home--journey container">
    <div class="home--journey-wrapper">
      <div class="home--journey-header">
        <div class="home--journey-header-title">
          {{ $t('home_journey.title') }}
          <span class="home--digitalize-content-bold primary-color">
            {{ $t('home_journey.title_branding') }}
          </span>
        </div>
        <div class="home--journey-header-subtitle">
          {{ $t('home_journey.subtitle') }}
        </div>
      </div>
      <div class="">
        <Cruise />
      </div>
    </div>
  </section>
</template>
<style lang="scss" scoped>
.home--journey {
  padding-top: 125px;
  .home--journey-wrapper {
    text-align: center;
    .home--journey-header-title {
      font-size: 40px;
      letter-spacing: -2px;
      font-family: 'CircularStd-Black';
    }
    .home--journey-header-subtitle {
      font-size: 16px;
      letter-spacing: -0.8px;
    }
  }
}
@media screen and (max-width: 1300px) {
  .home--journey {
    padding-top: 50px;
    .home--journey-wrapper {
      text-align: center;
      .home--journey-header-title {
        font-size: 35px;
        line-height: 35px;
        letter-spacing: -2px;
        font-family: 'CircularStd-Black';
      }
      .home--journey-header-subtitle {
        font-size: 16px;
        letter-spacing: -0.8px;
        padding-top: 10px;
      }
    }
  }
}
</style>
